import { TranslationKeys } from './types/translationStructure';

export const returnsEn = {
  form: {
    downloadTemplate: 'Download template',
    selectCsvFile: 'Select csv file',
    dragAndDropFileOrClickOnField:
      'Drag and drop the file or click on the field',
    password: 'Payment password',
    invalidPassword: 'Enter payment password',
    send: 'Send',
  },
  formTitle: 'Return to bank card',
  listTitle: 'Processed returns',
  title: 'Make a return',
  single: 'Single',
  mass: 'Mass',
  modal: {
    modalTitle: 'Confirm bulk refund execution',
    modalDescription:
      'Please confirm execution of refunds from file "<darker>{{fileName}}</darker>": <darker>{{rowsTotal}}</darker> operations for a total of <amount>{{amount}}</amount>',
    modalDescriptionWithValidation:
      ', of which valid <darker>{{rowsValidated}}</darker> operations for a total of <amountValidated>{{amountValidated}}</amountValidated>',
    modalDescriptionEnd:
      '. Please note that after confirmation it will be impossible to stop the execution.',
    okModalButton: 'Accept',
    cancelModalButton: 'Cancel',
    bulkRefundTransitionStarted: 'Bulk transaction processing started',
  },
} as const;

export const returnsRu: TranslationKeys<typeof returnsEn> = {
  form: {
    downloadTemplate: 'Скачать шаблон',
    selectCsvFile: 'Выберите csv файл',
    dragAndDropFileOrClickOnField: 'Перетащите файл или нажмите на поле',
    password: 'Платёжный пароль',
    invalidPassword: 'Укажите платёжный пароль',
    send: 'Отправить',
  },
  formTitle: 'Возврат на карту',
  listTitle: 'Проведенные возвраты',
  title: 'Сделать возврат',
  single: 'Единичный',
  mass: 'Массовый',
  modal: {
    modalTitle: 'Подтверждение запуска возвратов',
    modalDescription:
      'Подтвердите запуск возвратов из файла "<darker>{{fileName}}</darker>": всего <darker>{{rowsTotal}}</darker> операций на общую сумму <amount>{{amount}}</amount>',
    modalDescriptionWithValidation:
      ', из них валидных <darker>{{rowsValidated}}</darker> операций на общую сумму <amountValidated>{{amountValidated}}</amountValidated>',
    modalDescriptionEnd:
      '. Обратите внимание, что после подтверждения остановка возвратов станет невозможной.',
    okModalButton: 'Подтвердить',
    cancelModalButton: 'Отмена',
    bulkRefundTransitionStarted: 'Начата обработка массовой операции',
  },
} as const;


